const listeners = new Map();

function notify(workforceUid) {
  const group = listeners.get(workforceUid);
  if (!group) return;
  group.forEach((listener) => listener());
}

const devices = new Map();

export function publishWorkforceDevice(workforceUid, device) {
  if (!workforceUid) return;
  devices.set(workforceUid, device);
  notify(workforceUid);
}

export function getWorkforceDeviceSnapshot(workforceUid) {
  return devices.get(workforceUid);
}

export function subscribeWorkforceDevice(workforceUid, listener) {
  if (!listeners.has(workforceUid)) listeners.set(workforceUid, new Set());
  listeners.get(workforceUid).add(listener);
  return () => {
    const group = listeners.get(workforceUid);
    if (!group) return;
    group.delete(listener);
    if (group.size === 0) listeners.delete(workforceUid);
  };
}

export function readCreatedDevice(payload) {
  let current = payload;
  for (let depth = 0; depth < 4 && current; depth += 1) {
    if (current.uid || current.shortUid) {
      const shortUid = current.shortUid || (typeof current.uid === "string" ? current.uid.slice(0, 6) : null);
      const status = current.status === "linked" || current.status === "unlinked" || current.status === "pending" ? current.status : "pending";
      return { ...current, shortUid, status };
    }
    current = current.data;
  }
  return null;
}

export function readFetchedDevice(payload) {
  return readCreatedDevice(payload);
}

export function connectionFromDevice(device) {
  const liveLat = Number(device?.lastLatitude);
  const liveLng = Number(device?.lastLongitude);
  const liveAt = Date.parse(device?.lastLocationAt);
  if (Number.isFinite(liveLat) && Number.isFinite(liveLng)) {
    return { lat: liveLat, lng: liveLng, ...(Number.isFinite(liveAt) ? { at: liveAt } : {}) };
  }

  const record = device?.records?.[0];
  const gps = record?.gps;
  const recordLat = Number(gps?.latitude);
  const recordLng = Number(gps?.longitude);
  const recordAt = Date.parse(record?.recordedAt || record?.createdAt);
  if (Number.isFinite(recordLat) && Number.isFinite(recordLng)) {
    return { lat: recordLat, lng: recordLng, ...(Number.isFinite(recordAt) ? { at: recordAt } : {}) };
  }

  return null;
}

/** A stored point older than this is not the phone's current location. */
export const CURRENT_LOCATION_MAX_AGE_MS = 3 * 60_000;

export function isCurrentLocation(point, now = Date.now()) {
  if (!point || !Number.isFinite(point.at)) return false;
  const age = now - point.at;
  return age <= CURRENT_LOCATION_MAX_AGE_MS && age >= -30_000;
}

/** A refresh that comes back empty must not hide a pairing code. A linked device that is gone must leave the map. */
export function mergeDeviceState(current, incoming) {
  if (!incoming) {
    if (current?.status === "pending" && (current.uid || current.shortUid)) return current;
    return null;
  }
  if (current?.status === "linked" && incoming.status === "pending") return current;
  return { ...incoming };
}
